import AppForm from '../app-components/Form/AppForm';

Vue.component('document-template-form', {
    mixins: [AppForm],
    props: {
        'mode': {
            type: String,
            required: true
        },
        'documentTypes': {
            //type: Array,
            required: true
        },
        'companyContractTypes': {
            //type: Array,
            required: true
        },
        'positions': {
            //type: Array,
            required: true
        },
        'restaurants': {
            //type: Array,
            required: true
        },
        'documentTemplates': {
           type: Array,
        }
    },

    data: function () {
        return {
            form: {
                document_type_id: this.getParameterByName('documentType'),
                title: '',
                wysiwyg: '',
                company_contract_types: [],
                positions: [],
                restaurants: [],
                combinations: '',
            },
            templates: [],
            duplicityTemplate: {}
        }
    },

    methods: {
        onSubmit(submitType) {
            this.submiting = true;

            axios.post(this.action, this.form).then((response) => {
                return this.onSuccess(response.data, 'save');
            }).catch((errors) => {
                this.submiting = false;

                if(errors.response.status !== 422) { // only on diff response codes, because 422 is handled later in this.onFail processing
                    this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.server_error });
                }

                if (typeof errors.response.data.errors.combinations !== 'undefined') {
                    // nepýtajte sa nikto ... potrebujem vykreslovat krasny validacny error s font awesome ikonkou a ked na nu kliknem
                    // musí mi zobraziť modal ... Majstroval som s ChatGPT a toto je prvé funkčné riešenie, ako rozparsovať backend.
                    // nemám silu hľadať niečo krajšie
                    let errorMessage = errors.response.data.errors.combinations[0];
                    let regex = /\[([^\]]+)\]/;
                    let match = errorMessage.match(regex);

                    if (match) {
                        this.templates = JSON.parse(match[0]);
                    }
                }

                return this.onFail(errors.response.data.errors);
            });
            return true;
        },

        checkDuplicities(url) {
            axios.post(url, this.form).then((response) => {
                this.submiting = false;

                var bag = this.$validator.errors;
                bag.clear();

                this.onSuccess(response.data, 'check');
            }).catch((errors) => {
                this.submiting = false;

                if(errors.response.status !== 422) { // only on diff response codes, because 422 is handled later in this.onFail processing
                    this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.server_error });
                }

                if (typeof errors.response.data.errors.combinations !== 'undefined') {
                    // nepýtajte sa nikto ... potrebujem vykreslovat krasny validacny error s font awesome ikonkou a ked na nu kliknem
                    // musí mi zobraziť modal ... Majstroval som s ChatGPT a toto je prvé funkčné riešenie, ako rozparsovať backend.
                    // nemám silu hľadať niečo krajšie
                    let errorMessage = errors.response.data.errors.combinations[0];
                    let regex = /\[([^\]]+)\]/;
                    let match = errorMessage.match(regex);

                    if (match) {
                        this.templates = JSON.parse(match[0]);
                    }
                }

                return this.onFail(errors.response.data.errors);
            });
            return true;
        },

        onSuccess(data, successType) {
            console.log(data, successType)
            this.submiting = false;

            if (this.mode === "create" && data.redirect) {
                window.location.replace(data.redirect)
            }

            if(successType === 'save') {
                $(".button-save").hide().delay(1400).queue(function (next) {
                    $(this).fadeToggle("button-save");
                    next();
                });

                $(".button-saved").show().delay(1000).queue(function (next) {
                    $(this).fadeToggle("button-saved");
                    $(".edit-submit").css("pointer-events", "all");
                    next();
                });
            } else {
                $(".button-check").hide().delay(1400).queue(function (next) {
                    $(this).fadeToggle("button-check");
                    next();
                });

                $(".button-checked").show().delay(1000).queue(function (next) {
                    $(this).fadeToggle("button-checked");
                    $(".edit-submit").css("pointer-events", "all");
                    next();
                });
            }
        },

        onFail: function onFail(errors) {
            this.submiting = false;

            var bag = this.$validator.errors;
            bag.clear();
            Object.keys(errors).map(function (key) {
                var splitted = key.split('.', 2);

                if (splitted.length > 1) {
                    bag.add({ field: splitted[0] + '_' + splitted[1], msg: errors[key][0]});
                } else {
                    bag.add({ field: key, msg: errors[key][0]});
                }
            });

            this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.form_contains_errors });
        },

        getParameterByName(name) {
            const url = window.location.href;
            const paramRegex = new RegExp('[?&]' + name + '=([^&]*)');
            const match = url.match(paramRegex);
            return match && match[1];
        },

        showModal(templateId) {
            this.duplicityTemplate = this.documentTemplates.find((template) => template.id === templateId);
            this.$modal.show('show-duplicity-modal');
        }
    },
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/document-template/Form.js